"use client"

import { ColumnDef } from "@tanstack/react-table"
import { Checkbox } from "@/Components/ui/checkbox"
import { Key } from "react"


// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export type User = {
    id: Key | null
    forename: string
    surname: string
    displayName: string
    email: string
    userRole: "Admin" | "User"
}

export const user_columns: ColumnDef<User>[] = [
    {
        id: "select",
        header: ({ table }) => (
            <Checkbox
                id="table-select-all"
                checked={
                    table.getIsAllPageRowsSelected() ||
                    (table.getIsSomePageRowsSelected() && "indeterminate")
                }
                onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
                aria-label="Select all"
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                id={`table-select-row-${row.index}`}
                onClick={(e) => e.stopPropagation()}
                checked={row.getIsSelected()}
                onCheckedChange={(value) => row.toggleSelected(!!value)}
                aria-label="Select row"
                className="table-row-checkbox"
            />
        ),
        enableSorting: false,
        enableHiding: false,
    },
    {
        id: "id",
        accessorKey: "id",
        header: "ID",
        cell: ({ row }) => {
            const id = row.getValue("id");
            return <div className="pl-4">{ id as number }</div>
        },
    },
    {
        id: "forename",
        accessorKey: "forename",
        header: "Forename",
        cell: ({ row }) => {
            const forename = row.getValue("forename");
            return <div className="text-center">{ forename as string }</div>
        },
        size: 200,
    },
    {
        id: "surname",
        accessorKey: "surname",
        header: "Surname",
        cell: ({ row }) => {
            const surname = row.getValue("surname");
            return <div className="text-center">{ surname as string }</div>
        },
        size: 200,
    },
    {
        id: "displayName",
        accessorKey: "displayName",
        header: "Display Name",
        cell: ({ row }) => {
            const displayName = row.getValue("displayName");
            return <div className="text-center">{displayName as string}</div>
        },
        size: 200,
    },
    {
        id: "email",
        accessorKey: "email",
        header: "Email",
        cell: ({ row }) => {
            const email = row.getValue("email");
            return <div className="text-center">{email as string}</div>
        },
        size: 200,
    },
]

export const columnDisplayNames: [string, string][] = [
    ["id", "ID"],
    ["forename", "Forename"],
    ["surname", "Surname"],
    ["displayName", "Display Name"],
    ["email", "Email"],
]